import React, { useState } from 'react';
import { Col, Container, Row } from 'coreComponents/design-system/flow-content';
import { Input, StyledButton } from 'coreComponents/design-system/Form';
import { Header, Link, Paragraph, } from 'coreComponents/design-system/typography';
import { isEmptyObject } from 'helpers/is-empty-object';
export const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const handleSave = e => {
        const errorMap = {};
        if (email.length < 1) {
            errorMap['email'] = 'Your email is required.';
        }
        else if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
            errorMap['email'] = 'Invalid email format.';
        }
        if (password.length < 1) {
            errorMap['password'] = 'Your password is required.';
        }
        if (!isEmptyObject(errorMap)) {
            e.preventDefault();
            setErrors(errorMap);
        }
    };
    const getErrorMessage = (field) => errors[field];
    const calculateFieldState = (field) => getErrorMessage(field) ? 'error' : 'normal';
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Header.h2, { style: { marginBottom: '12px' }, className: "flex justify-center lg:justify-start" }, "CUSTOMER LOGIN"))),
            React.createElement(Row, null,
                React.createElement(Col, { style: { marginBottom: '12px' }, className: "flex flex-column items-center lg:items-start" },
                    React.createElement("div", { className: "flex-shrink w-max" }, "For existing customer"))),
            React.createElement(Row, null,
                React.createElement(Col, { style: { fontSize: '10px' } },
                    React.createElement(Paragraph, { style: { fontSize: '10px' } },
                        "REQUIRED ",
                        React.createElement("span", { style: { color: '#EF3A4C' } }, "*")))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "Email Address", placeholder: "Email Address", name: "customer[email]", value: email, onChangeValue: setEmail, state: calculateFieldState('email'), errorMessage: getErrorMessage('email'), type: "email", required: true, mask: true, dataTest: 'email' }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "Password", placeholder: "Password", name: "customer[password]", value: password, onChangeValue: setPassword, state: calculateFieldState('password'), errorMessage: getErrorMessage('password'), type: "password", required: true, mask: true, dataTest: 'password' }))),
            React.createElement(Row, null,
                React.createElement(Col, { style: { marginBottom: '20px' } },
                    React.createElement(Link, { className: "switch-form", style: { fontSize: '12px' } }, "Forgot Password?"))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(StyledButton, { "data-test": "login-button", type: "submit", onClick: handleSave, style: {
                            fontSize: '16px',
                            fontWeight: 600,
                            height: '40px',
                            minHeight: '40px',
                        } }, "Login"))))));
};
LoginForm.defaultProps = {};
export default LoginForm;
